import consumer from "./consumer"


$(document).ready(function() {

  const element = document.getElementById('room-score-id');
  const room_id_score = element ? element.getAttribute('data-room-id') : '';

  console.log('room-score-id: ' + room_id_score);



  if (room_id_score != '' ){
    consumer.subscriptions.create({channel: "ResultadosHeatChannel", room:room_id_score},{ 
      connected() {
        // Called when the subscription is ready for use on the server
        console.log("Conectado al ResultadosHeat channel: " + room_id_score)
        
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
      },

      received(data) {
        // Called when there's incoming data on the websocket for this channel
        console.log("en resultados_heat_channel.js ")
        var datajson = JSON.parse(data);
        console.log("----------------------------------");
        console.log("datajson2: " + datajson["data"]);
        console.log("pendientes: " + datajson["pendientes"]);
        console.log("heat_id: " + datajson["heat_id"]);

        console.log("data: " + data);

        if (datajson["data"] == "refresh"){
          //Hacer clic en el link para actualizar la pagina (para que aparezca el reloj)
          document.getElementById("actualizar_pagina").click();
        }

        if (datajson["data"] == "nuevos_puntajes") {
          var iframe = document.getElementById('tabla_puntajes_heat');
          if (iframe !== null) {
            iframe.src = iframe.src; // Recarga el iframe estableciendo su src al mismo valor  
          }     

          var iframe = document.getElementById('tabla_puntajes_heat_mobile');
          if (iframe !== null) {
            iframe.src = iframe.src; // Recarga el iframe estableciendo su src al mismo valor  
          } 

          
          //Actualizar iframe de ifrma de herat en vivo
          var iframe_mobile_envivo = document.getElementById('tabla_puntajes_heat_mobile');     

          if (iframe_mobile_envivo !== null) {
            console.log("Se recargo iframe de heat vista mobile");
            iframe_mobile_envivo.src = iframe_mobile_envivo.src; // Recarga el iframe estableciendo su src al mismo valor  
          }


          var iframe_mobile = document.getElementById('iframe_resultados_' + datajson["heat_id"]);

          if (iframe_mobile !== null) {
            console.log("if (iframe_mobile !== null)...")
            iframe_mobile.src = iframe_mobile.src; // Recarga el iframe estableciendo su src al mismo valor  
          }
                
          if (document.getElementById("finalizar_heat_"+room_id_score)) {
            $("#finalizar_heat_"+room_id_score).removeClass("ocultar");
          }

            console.log("solicitud de recargar el iframe...")          
        }


        if (datajson["pendientes"] == "true") {
          $("#finalizar_ok_"+room_id_score).attr('data-notas_pendientes', 'true');
        }

        if (datajson["pendientes"] == "false") {
          $("#finalizar_ok_"+room_id_score).attr('data-notas_pendientes', 'false');
        }

        if (datajson["posiciones_repetidas"] == "true") {
          $("#finalizar_ok_"+room_id_score).attr('data-pos_repetidas', 'true');
        }

        if (datajson["posiciones_repetidas"] == "false") {
          $("#finalizar_ok_"+room_id_score).attr('data-pos_repetidas', 'false');
        }

      }
    });

  }


    
});
